/* ============================================================
   ADEQO COLLECTION LANDING — gevelfamilie (col-gv-*)
   Twee interacties, allebei zonder rekenwerk in de browser:
   1. Kleurkeuze. Eén staat voor de hele pagina: de kiezers in de hero,
      de schaduwlijn en het systeemblok sturen dezelfde kleur, en elk
      element met data-gv-colour="<sleutel>" wordt zichtbaar of niet.
   2. Planklengte. De kaarten renderen per lengte een eigen prijsblok
      (Liquid, met de live prijs), de knop toont er één.
   De sleutel is de handleized kleur van het product (eiken-zwart, ...),
   dezelfde als in col-system.
   ============================================================ */

(function () {
  'use strict';

  function initColour(root) {
    var buttons = root.querySelectorAll('[data-gv-colour-btn]');
    if (!buttons.length) return;

    var items = root.querySelectorAll('[data-gv-colour]');
    var captions = root.querySelectorAll('[data-gv-colour-name]');

    function apply(key) {
      var name = '';
      buttons.forEach(function (b) {
        var on = b.getAttribute('data-gv-colour-btn') === key;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && !name) name = b.getAttribute('data-gv-colour-label') || b.textContent.trim();
      });
      items.forEach(function (el) {
        var on = el.getAttribute('data-gv-colour') === key;
        el.classList.toggle('is-active', on);
        el.classList.toggle('is-hidden', !on);
      });
      captions.forEach(function (c) { c.textContent = name; });
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.getAttribute('data-gv-colour-btn'));
      });
    });
  }

  function initLength(root) {
    var buttons = root.querySelectorAll('[data-gv-len-btn]');
    if (buttons.length < 2) return;

    var blocks = root.querySelectorAll('[data-gv-len]');

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var len = b.getAttribute('data-gv-len-btn');
        buttons.forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        blocks.forEach(function (el) {
          el.hidden = el.getAttribute('data-gv-len') !== len;
        });
        /* Het beeld van de kaart linkt naar het product van de gekozen lengte. */
        root.querySelectorAll('[data-gv-panel-link]').forEach(function (link) {
          var panel = link.closest('.gv-panel');
          var shown = panel && panel.querySelector('[data-gv-len]:not([hidden])');
          if (shown && shown.getAttribute('data-gv-url')) link.href = shown.getAttribute('data-gv-url');
        });
      });
    });
  }

  function init() {
    var root = document.querySelector('.col-landing') || document;
    initColour(root);
    initLength(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
